import { render, staticRenderFns } from "./DocumentTypes.vue?vue&type=template&id=718c9cca&scoped=true&"
import script from "./DocumentTypes.vue?vue&type=script&lang=js&"
export * from "./DocumentTypes.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypes.vue?vue&type=style&index=0&id=718c9cca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718c9cca",
  null
  
)

export default component.exports